export default "__VITE_ASSET__tBbgx9wP__"